export default __webpack_public_path__ + "static/media/bar.f21ca388.png";